<template>
  <div class="zj-flex-column">
    <div class="collapse-menu-item" @click="innerIsCollapse = !innerIsCollapse">
      <i v-if='innerIsCollapse' class="el-icon-s-unfold"></i>
      <div v-if='!innerIsCollapse'>
        <span>系统菜单</span>
        <i class="el-icon-s-fold"></i>
        <i class="el-icon-search" style="margin-left:10px;" @click.stop="filterShow = !filterShow"></i>
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <div v-if="!innerIsCollapse && filterShow">
        <el-input class="select__filter" v-model="query" size="small" placeholder="输入关键字筛选菜单"
          @mouseenter.native="inputHover = true" @mouseleave.native="inputHover = false" ref="filterInput">
          <i slot="suffix" :class="['el-input__icon', 'el-icon-' + inputIcon]" @click="clearQuery"></i>
        </el-input>
      </div>
    </transition>
    <div class="aside-menu">
      <div class="aside-menu-ct">
        <el-scrollbar>
          <el-menu v-menuShowText :default-active="activeTabName" class="menu-tree-ct" router :collapse="innerIsCollapse"
            @select="innerIsCollapse = true">
            <!-- 首页 -->
            <el-menu-item v-if="haveVm()" index="main" route="/main" key="main">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <!-- 权限树加载 -->
            <menu-tree-collapse :collapse="innerIsCollapse" :menuTreeItem="item" v-for="item in menuTreeListFilterData"
              :key="item.menu_id" />
          </el-menu>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import MenuTreeCollapse from "@/common/components/menu-tree-collapse";
import { mapState } from "vuex";
import PinYinMatch from 'pinyin-match';

export default {
  components: {
    MenuTreeCollapse
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      query: "",
      inputHover: false,
      filterShow: false
    }
  },
  computed: {
    ...mapState("navTabs", ["menuTreeList", "menuTreeListFlatten"]),
    activeTabName() {
      return this.$store.state.navTabs.activeTabName;
    },
    innerIsCollapse: {
      get() {
        return this.isCollapse;
      },
      set(val) {
        if (val) {
          this.filterShow = false;
          this.query = "";
        }
        this.$emit('update:isCollapse', val);
      }
    },
    inputIcon() {
      return this.query.length > 0 && this.inputHover ? 'circle-close' : 'search';
    },
    menuTreeListFilterData() {
      if (!this.query) return this.menuTreeList;
      var queryFilterData = this.menuTreeListFlatten.filter(item => {
        return item.menu_name.toLowerCase().indexOf(this.query.toLowerCase()) > -1 || PinYinMatch.match(item.menu_name, this.query);
      })
      var queryTreeData = [];
      for (var i = 0; i < queryFilterData.length; i++) {
        // 向上递归查找父节点
        var oneData = JSON.parse(JSON.stringify(queryFilterData[i]));
        oneData.children = [];
        this.getAllFatherNode(oneData, queryTreeData)
      }
      return queryTreeData;
    }
  },
   watch: {
    filterShow(newVal, oldVal) {
      if(this.filterShow) {
        this.$nextTick(() => {
          this.$refs.filterInput.focus();
        })
      }
    }
  },
  methods: {
    haveVm() {
      return vm;
    },
    clearQuery() {
      if (this.inputIcon === 'circle-close') {
        this.query = '';
      }
    },
    getAllFatherNode(node, result) {
      if (!result) result = [];
      //先看result里面有没有这个节点，有就不添加了
      var hanThis = result.filter(item => item.menu_id == node.menu_id);
      if (!hanThis.length) {
        if (node.menu_pid) {
          var fatherNode = this.menuTreeListFlatten.filter(item => item.menu_id == node.menu_pid);
          if (fatherNode.length) {
            //如果有父节点，继续递归
            var oneData = JSON.parse(JSON.stringify(fatherNode[0]));
            oneData.children = [];
            this.getAllFatherNode(oneData, result)
            //递归完把自身添加进去
            var fatherNode2 = this.findFatherNode(result, oneData);
            if (fatherNode2 != null) {
              var hanThisChild = fatherNode2.children.filter(item => item.menu_id == node.menu_id);
              if (!hanThisChild.length)
                fatherNode2.children.push(node);
            }
          }
        } else {
          node.children = [];
          result.push(node);
        }
      }

      return result;
    },
    findFatherNode(tree, node) {
      //先找自身，再找子级
      var result = tree.filter(item => item.menu_id == node.menu_id);
      if (result.length) {
        return result[0];
      } else {
        for (var i = 0; i < tree.length; i++) {
          var hasNode = this.findFatherNode(tree[i].children, node);
          if (hasNode) {
            return hasNode;
          }
        }
      }
      return null;
    }
  },
  mounted() {
    this.$root.$on("on-collapse-click", () => {
      this.innerIsCollapse = true;
    });
  }
}
</script>

<style scoped>
.collapse-menu-item {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  vertical-align: middle;
  background-color: #ddecfd;
  cursor: pointer;
}
.aside-menu {
  flex: 1;
  position: relative;
}
.aside-menu-ct {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  background-color: white;
}
.menu-tree-ct {
  height: 100%;
  user-select: none;
}
.select__filter {
  text-align: center;
  box-sizing: border-box;
  display: block;
  width: 90%;
  margin: 5px auto;
}
</style>
<style>
.aside-menu .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden !important;
}
.select__filter .el-input__inner {
  height: 32px;
  width: 100%;
  font-size: 12px;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 16px;
  padding-left: 10px;
  padding-right: 30px;
}
</style>
